import {Route} from "@angular/router";
import {guardExercisesWatch} from "@/app/routes/guards/exercises-guard";

const NAME = 'Упражнения'

export const typesOfExamination: Route[] = [
    {
        path: 'types-of-examination',
        loadComponent: () => import('@components/guides/types-of-examination/types-of-examination.component').then(c => c.TypesOfExaminationComponent),
        canActivate: [guardExercisesWatch],
        data: {
            breadcrumbs: [
                {name: 'Испытания', url: '/'},
                {name: NAME, url: null},
            ],
            title: NAME,
            reuse: true,
            searchString: true
        },

    },
    {
        path: 'types-of-examination/:id',
        loadComponent: () => import('@components/guides/types-of-examination/types-of-examination-details/types-of-examination-details.component').then(c => c.TypesOfExaminationDetailsComponent),
        canActivate: [guardExercisesWatch],
        data: {
            breadcrumbs: [
                {name: 'Испытания', url: '/'},
                {name: NAME, url: '/types-of-examination/'},
            ],
        },

    },
]
